import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import PropTypes from "prop-types";
import Loader from "../../../general/Loader";
import "./ExtensionPublishConfirmation.css";

const ExtensionPublishConfirmation = ({
    visible,
    extension,
    isAdmin = false,
    isProcessing,
    error,
    onConfirm,
    onCancel,
}) => {
    if (!extension) return null;

    return (
        <Dialog
            header={isAdmin ? "Publish Extension" : "Submit for Review"}
            visible={visible}
            style={{ width: "440px" }}
            onHide={onCancel}
            modal
            dismissableMask
            className="extension-publish-confirmation"
        >
            {isProcessing && <Loader />}

            {isAdmin ? (
                <p>
                    Publish <strong>{extension.extensionName}</strong> and make it
                    available to others?
                </p>
            ) : (
                <>
                    <p>
                        Submit <strong>{extension.extensionName}</strong> for review?
                    </p>
                    <p style={{ color: "#555", fontSize: "0.9rem", marginTop: "8px" }}>
                        An admin will review your extension. Once it&apos;s approved, it
                        will be published and made available to others. You&apos;ll be
                        able to track its status until then.
                    </p>
                </>
            )}

            {error && <div className="error-message">{error}</div>}

            <div className="confirmation-actions">

                <Button
                    label="Cancel"
                    icon="pi pi-times"
                    onClick={onCancel}
                    className="p-button-secondary"
                    disabled={isProcessing}
                />
                 <Button
                    label={isAdmin ? "Publish" : "Submit for Review"}
                    icon={isAdmin ? "pi pi-check" : "pi pi-send"}
                    onClick={onConfirm}
                    className="p-button-success"
                    disabled={isProcessing}
                    autoFocus
                />
            </div>
        </Dialog>
    );
};

ExtensionPublishConfirmation.propTypes = {
    visible: PropTypes.bool.isRequired,
    extension: PropTypes.object,
    isAdmin: PropTypes.bool,
    isProcessing: PropTypes.bool,
    error: PropTypes.string,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

export default ExtensionPublishConfirmation;